module.exports = __webpack_public_path__ + "static/media/christopher-tan.68ed1d9e.jpg";